/* Plantica — opening the experts modal

   The trigger is a real link to the experts page. This upgrades it to open the
   modal instead, but only when the modal is actually on the page — so a page
   that carries the row without the modal section still works, and so does a
   visitor with no JavaScript.

   The modal itself is the theme's `basic-modal`, which brings the focus trap,
   Escape, the backdrop and the scroll lock. Its `show()` is called directly
   rather than relying on `aria-controls`: the theme binds those listeners once,
   when the modal connects, so an attribute added later would be ignored. */

(() => {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-plantica-modal]');
    if (!trigger) return;

    const modal = document.getElementById(trigger.dataset.planticaModal);
    if (!modal) return; // no modal here — let the link do its job

    event.preventDefault();

    if (typeof modal.show === 'function') modal.show();
    else modal.setAttribute('open', '');
  });
})();
